module.exports = __webpack_public_path__ + "remove-v1-c5da545b.svg";